module.exports = __webpack_public_path__ + "img/a.c414c32e.jpg";